import { DatePicker, Modal } from "antd";
import { CloseIcon } from "../../icons/CloseIcon";
import { CalendIcon } from "../../icons/CalendIcon";
import { Title } from "../../components/Text";
import { BorderedField } from "../../components/Flex";


const UpdateContractsDatesModal = ({ visible, onCancel, onOk, onChange }) => {

    return(
        <Modal
            centered
            width={600}
            className="sp-modal"
            visible={visible}
            closeIcon={<CloseIcon />}
            onCancel={() => onCancel()}
            onOk={onOk}
            okButtonProps={{style: { height: "40px", padding: "0px 21px", background: "var(--sp-main-color)", borderRadius: "8px", border: "none" }}}
            cancelButtonProps={{type: "link", style:{ fontSize: "14px", color: "var(--sp-main-color)" }}}
            >
                <Title h4 style={{ padding: "8px 0"}}>Update contracts for all assigned organizations</Title>
                <BorderedField style={{ height: "42px" }}>
                    <DatePicker
                        placeholder="Enter end date of the contract for all assigned organizations"
                        allowClear={false}
                        bordered={false}
                        suffixIcon={<CalendIcon />}
                        style={{ width: "100%" }}
                        onChange={onChange}
                    />
                </BorderedField>
        </Modal>
    )
};

export { UpdateContractsDatesModal };